// Shared between AddCompanyModal (new client) and CodePolicySection
// (editing an existing client) so the two pickers never drift apart.
export const STRATEGIES = [
  {
    value: 'SEQUENTIAL',
    label: 'Sequential',
    hint: 'Predictable, sortable, counts up',
    sample: (prefix, sep) => `${prefix || 'RAY'}${sep}0001`,
  },
  {
    value: 'RANDOM_NUMERIC',
    label: 'Random — numbers',
    hint: 'Non-guessable, digits only',
    sample: (prefix, sep) => `${prefix || 'RAY'}${sep}483920`,
  },
  {
    value: 'RANDOM_ALPHANUMERIC',
    label: 'Random — letters & numbers',
    hint: 'Highest entropy per character',
    sample: (prefix, sep) => `${prefix || 'RAY'}${sep}7K9QX2`,
  },
  {
    value: 'RANDOM_ALPHA',
    label: 'Random — letters only',
    hint: 'Visually distinct from numeric codes',
    sample: (prefix, sep) => `${prefix || 'RAY'}${sep}QXKZDM`,
  },
  {
    value: 'TEMPLATE',
    label: 'Advanced (template)',
    hint: 'Build your own, e.g. year + sequence',
    sample: (prefix, sep) => `${prefix || 'RAY'}${sep}26${sep}0001`,
  },
];

export const CASING_OPTIONS = ['UPPER', 'LOWER', 'PRESERVE'];

export const TEMPLATE_TOKENS = [
  { token: '{PREFIX}', desc: "the client's prefix" },
  { token: '{SEP}', desc: 'the separator' },
  { token: '{SEQ:4}', desc: 'zero-padded sequence number (4 digits)' },
  { token: '{RAND:6}', desc: 'random digits (6 chars)' },
  { token: '{RANDA:6}', desc: 'random letters (6 chars)' },
  { token: '{YY}', desc: '2-digit year' },
  { token: '{YYYY}', desc: '4-digit year' },
  { token: '{MM}', desc: '2-digit month' },
];

// Auto-suggest a prefix from a typed company name: "Raya Contact Center"
// -> "RAY". Falls back to the first 3 alphanumeric characters found
// anywhere in the string if the name doesn't start with letters.
export const suggestPrefix = (companyName) => {
  if (!companyName) return '';
  const letters = companyName.trim().match(/^[A-Za-z]+/)?.[0];
  const source = letters || companyName.replace(/[^A-Za-z0-9]/g, '');
  return source.slice(0, 3).toUpperCase();
};
